"use client";

import type { VideoContainer } from "mediatools";
import { useTranslations } from "next-intl";
import { VideoFormatRadio } from "./forms";
import type { MediaOperation, OperationOptionsProps } from "./types";
import { runVideoConversion } from "./video";

interface ConvertVideoOpts {
  format: VideoContainer;
}

function ConvertVideoForm({
  options,
  setOptions,
  disabled,
}: OperationOptionsProps<ConvertVideoOpts>) {
  const t = useTranslations("mediaTools.options.convertVideo");
  return (
    <VideoFormatRadio
      value={options.format}
      onChange={(format) => setOptions({ format })}
      disabled={disabled}
      label={t("formatLabel")}
    />
  );
}

export const convertVideoOperation: MediaOperation<ConvertVideoOpts> = {
  id: "convert-video",
  group: "video",
  inputKinds: ["video"],
  outputKind: "video",
  showSourcePreview: true,
  defaultOptions: { format: "mp4" },
  OptionsForm: ConvertVideoForm,
  run: (ctx, options) => runVideoConversion(ctx, { format: options.format }),
};
